import React, { useState } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { NavLink } from "reactstrap";
import Swal from 'sweetalert2'

const CardCartConfirm = ({ ...props }) => {
  const renderCardImage = (image) => {
    if (image) {
      return image;
    } else {
      return "";
    }
  };
  const formatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'VND',
    minimumFractionDigits: 0
  })

  //Set size Image 
  let widthDetail = 300
  let type = ""
  if(props.widthDetail)
    widthDetail = parseInt(props.widthDetail)
  if(props.type)
    type = props.type

  const renderProductNameInfo = () => {
    if(type == "confirm")
      return(
        <b>{props.item.productName}</b>
      )
    return(
      <b className="productNameInfo">{props.item.productName}</b>
    )
  }
  
  return (
    <>
      <div className="row" style={{ paddingLeft:0, paddingRight:10 }}>
          <div className="col-md-4 col-xs-12 text-center">
            <img src={renderCardImage(props.item.image)} className="productImage" style={{ width: widthDetail }} />
            <div className="col text-center">              
              {renderProductNameInfo()}
            </div>
          </div>
          <div className="col-md-8 col-xs-12 text-center" >
            <div className="row" style={{ paddingTop: 50, fontSize:12 }} id="webCartInfo">
                <div className="col-md-4 text-center">{formatter.format(props.item.price)}</div>
                <div className="col-md-4 text-center">
                  <b> {props.item.quantity} </b>
                </div>
                <div className="col-md-4 text-center"><b>{formatter.format(props.item.price*props.item.quantity)}</b></div>
            </div>
            <div className="row" style={{ paddingTop: 50, fontSize:15 }} id="mobileCartInfo">
                <div className="col-md-4 text-center">Đơn giá: {formatter.format(props.item.price)}</div>
                <div className="col-md-4 text-center">Số lượng: <b> {props.item.quantity} </b>
                </div>
                <div className="col-md-4 text-center">Tổng: <b>{formatter.format(props.item.price*props.item.quantity)}</b></div>
            </div>
          </div>
      </div>
      <hr className="divider" />
    </>
  );
};

export default connect()(withRouter(CardCartConfirm));
